import { Typography } from 'antd'
import classnames from 'classnames'

export default function MyParagraph({ small = false, medium = false, className, ...props }) {
  return (
    <Typography.Paragraph
      className={classnames(className, {
        'font-size-small': small,
        'font-medium': medium,
      })}
      {...props}
    />
  )
}
